import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-enterprise';
import { ModelLibrary } from 'src/app/shared/models/model-library';
import { CompoundRenderer } from 'src/app/shared/renderers/compound/compound.component';
import { Constants } from 'src/app/shared/utils/constants';

@Injectable({
  providedIn: 'root',
})

export class InverseModelingModelsColDef {

  public getColumnsDefinition(swModels: ModelLibrary[], aquaticModels: ModelLibrary[], isProjectOwnershipValid: boolean): ColDef[] {
    return [
      {
        headerName: 'Compound',
        field: 'metaboliteName',
        width: 250,
        cellRenderer: CompoundRenderer,
        cellRendererParams: {
          filter: false,
          disabled: !isProjectOwnershipValid,
          validateModel: true,
          compartment: Constants.COMPARTMENTS.SURFACE_WATER.replace(" ", "").toLowerCase()
        },
        filter: 'agSetColumnFilter',
        wrapText: true,
        resizable: true,
        sortable: true,
        editable: false,
      },
      {
        headerName: 'SW Models',
        field: Constants.COMPARTMENTS.SURFACE_WATER.replace(" ","").toLowerCase(),
        width: 250,
        cellRenderer: 'listBoxRenderer',
        cellRendererParams: (params: any) => {
          return{
            options: swModels,
            optionValue: 'modelPk',
            optionLabel: 'nameVersion',
            checkbox: true,
            filter: false,
            multiple: true,
            disabled: !isProjectOwnershipValid || params.data.disabled,
            validateModel: true,
            compartment: Constants.COMPARTMENTS.SURFACE_WATER.replace(" ","").toLowerCase()
          }
        },
        filter: 'agSetColumnFilter',
        wrapText: true,
        resizable: true,
        sortable: true,
        editable: false,
      },
      {
        headerName: 'Aquatic',
        field: 'aquatic',
        width: 250,
        cellRenderer: 'listBoxRenderer',
        cellRendererParams: (params: any) => {
          return{
            options: aquaticModels,
            optionValue: 'name',
            optionLabel: 'name',
            checkbox: true,
            filter: false,
            multiple: true,
            disabled: !isProjectOwnershipValid || params.data.disabled,
            validateModel: true,
            compartment: Constants.COMPARTMENTS.AQUATIC.replace(" ","").toLowerCase()
          }
        },
        filter: 'agSetColumnFilter',
        wrapText: true,
        resizable: true,
        sortable: true,
        editable: false,
      }
    ];
  }
}
